<template>
  <div>
    <ThePageHeader :title="'Adatkezelési tájékoztató'" />

    <div class="mt-5 maximize">
      <p>
        A Körös Print-Pack Kft., (továbbiakban: Vállalkozás) jelen adatvédelmi
        tájékoztató közzététele útján tesz eleget az érintettek személyes adatok
        kezelésére vonatkozó, a 2016/679 Rendelete (GDPR) által előírt előzetes
        tájékoztatási kötelezettségének.
      </p>

      <p>
        I. AZ ADATKEZELŐ ADATAI
      </p>

      <p>
        A Vállalkozás tájékoztatja az érintettet,
        hogy személyes adatainak kezelése körében Adatkezelőnek minősül.
      </p>

      <p>
        Cég neve: Körös Print-Pack Kft.<br>
        Székhelye: 5600 Békéscsaba, Orosházi u. 32.<br>
        Cégjegyzékszám: 04-09-001059<br>
        Adószám: 10264175.2-04<br>
        Telefon: 66/447-608<br>
        Képviselő neve: Tóth János ügyvezető<br>
        E-mail cím: info@print-pack.hu<br>
        Weboldal: www.print-pack.hu
      </p>

      <p>
        A személyes adatokat a Vállalkozás a vonatkozó adatkezelési célhoz kapcsolódó hozzáférési
        jogosultságokkal rendelkező munkavállalói, illetve a Vállalkozás részére szolgáltatási
        szerződések alapján adatfeldolgozási tevékenységet végző személyek,
        szervezetek ismerhetik meg, a Vállalkozás által meghatározott terjedelemben
        és a tevékenységük végzéséhez szükséges mértékben.
      </p>

      <p>
        II. AZ ADATFELDOLGOZÓ MEGNEVEZÉSE<br>
        A Vállalkozás az általa önkéntes hozzájárulás alapján kezelt személyes
        adatok körében megbízott külső adatfeldolgozót nem vesz igénybe.
      </p>

      <p>
        III. FOGALOMMEGHATÁROZÁSOK
      </p>

      <p>
        1. „személyes adat”: azonosított vagy azonosítható természetes személyre („érintett”)
        vonatkozó bármely információ; azonosítható az a természetes személy, aki közvetlen vagy
        közvetett módon, különösen valamely azonosító, például név, szám, helymeghatározó adat,
        online azonosító vagy a természetes személy testi, fiziológiai, genetikai, szellemi,
        gazdasági, kulturális vagy szociális azonosságára vonatkozó egy vagy több tényező
        alapján azonosítható;
      </p>

      <p>
        2. „adatkezelés”: a személyes adatokon vagy adatállományokon automatizált vagy
        nem automatizált módon végzett bármely művelet vagy műveletek összessége, így
        a gyűjtés, rögzítés, rendszerezés, tagolás, tárolás, átalakítás vagy
        megváltoztatás, lekérdezés, betekintés, felhasználás, közlés továbbítás,
        terjesztés vagy egyéb módon történő hozzáférhetővé tétel útján,
        összehangolás vagy összekapcsolás, korlátozás, törlés, illetve megsemmisítés;
      </p>

      <p>
        3. „az adatkezelés korlátozása”: a tárolt személyes adatok megjelölése
        jövőbeli kezelésük korlátozása céljából;
      </p>

      <p>
        4. „profilalkotás”: személyes adatok automatizált kezelésének bármely olyan formája,
        amelynek során a személyes adatokat valamely természetes személyhez fűződő bizonyos
        személyes jellemzők értékelésére, különösen a munkahelyi teljesítményhez, gazdasági
        helyzethez, egészségi állapothoz, személyes preferenciákhoz, érdeklődéshez,
        megbízhatósághoz, viselkedéshez, tartózkodási helyhez vagy mozgáshoz kapcsolódó
        jellemzők elemzésére vagy előre jelzésére használják;
      </p>

      <p>
        5. „álnevesítés”: a személyes adatok olyan módon történő kezelése, amelynek következtében
        további információk felhasználása nélkül többé már nem állapítható meg, hogy
        a személyes adat mely konkrét természetes személyre vonatkozik, feltéve hogy
        az ilyen további információt külön tárolják, és technikai és szervezési
        intézkedések megtételével biztosított, hogy azonosított vagy azonosítható
        természetes személyekhez ezt a személyes adatot nem lehet kapcsolni;
      </p>

      <p>
        6. „nyilvántartási rendszer”: a személyes adatok bármely módon – centralizált,
        decentralizált vagy funkcionális, vagy földrajzi szempontok szerint – tagolt
        állománya, amely meghatározott ismérvek alapján hozzáférhető;
      </p>

      <p>
        7. „adatkezelő”: az a természetes vagy jogi személy, közhatalmi szerv,
        ügynökség vagy bármely egyéb szerv, amely a személyes adatok kezelésének
        céljait és eszközeit önállóan vagy másokkal együtt meghatározza;
        ha az adatkezelés céljait és eszközeit az uniós vagy a tagállami
        jog határozza meg, az adatkezelőt vagy az adatkezelő kijelölésére
        vonatkozó különös szempontokat az uniós vagy a tagállami jog is meghatározhatja;
      </p>

      <p>
        8. „adatfeldolgozó”: az a természetes vagy jogi személy, közhatalmi
        szerv, ügynökség vagy bármely egyéb szerv, amely az adatkezelő
        nevében személyes adatokat kezel;
      </p>

      <p>
        9. „címzett”: az a természetes vagy jogi személy, közhatalmi szerv,
        ügynökség vagy bármely egyéb szerv, akivel, vagy amellyel a személyes
        adatot közlik, függetlenül attól, hogy harmadik fél-e. Azon közhatalmi
        szervek, amelyek egy egyedi vizsgálat keretében az uniós vagy
        a tagállami joggal összhangban férhetnek hozzá személyes adatokhoz,
        nem minősülnek címzettnek; az említett adatok e közhatalmi szervek
        általi kezelése meg kell, hogy feleljen az adatkezelés
        céljainak megfelelően az alkalmazandó adatvédelmi szabályoknak;
      </p>

      <p>
        10. „harmadik fél”: az a természetes vagy jogi személy, közhatalmi
        szerv, ügynökség vagy bármely egyéb szerv, amely nem azonos az
        érintettel, az adatkezelővel, az adatfeldolgozóval vagy azokkal
        a személyekkel, akik az adatkezelő vagy adatfeldolgozó közvetlen
        irányítása alatt a személyes adatok kezelésére felhatalmazást kaptak;
      </p>

      <p>
        11. „az érintett hozzájárulása”: az érintett akaratának önkéntes,
        konkrét és megfelelő tájékoztatáson alapuló és egyértelmű
        kinyilvánítása, amellyel az érintett nyilatkozat vagy a
        megerősítést félreérthetetlenül kifejező cselekedet
        útján jelzi, hogy beleegyezését adja az őt érintő személyes adatok kezeléséhez;
      </p>

      <p>
        12. „adatvédelmi incidens”: a biztonság olyan sérülése, amely
        a továbbított, tárolt vagy más módon kezelt személyes adatok
        véletlen vagy jogellenes megsemmisítését, elvesztését,
        megváltoztatását, jogosulatlan közlését vagy az azokhoz
        való jogosulatlan hozzáférést eredményezi;
      </p>

      <p>
        13. „vállalkozás”: gazdasági tevékenységet folytató természetes
        vagy jogi személy, függetlenül a jogi formájától, ideértve
        a rendszeres gazdasági tevékenységet folytató személyegyesítő
        társaságokat és egyesületeket is.
      </p>

      <p>
        IV. ADATKÉRÉS<br>
        A Weboldal használatához a Látogatónak (Érintett) általában
        semmilyen személyes adatot nem szükséges megadni.<br>
        Kizárólag kapcsolatfelvétel céljából („Kapcsolatfelvétel – E-mail teszt)
        van lehetőség (nem kötelező) személyes adat megadására.<br>
        Személyes adatok köre: tekintettel arra, hogy a web lap látogatásakor
        személyes adatot nem kell megadni, amennyiben a látogató ezt mégis
        megteszi, az üzemeltető azonnal törli azokat.<br>
        A honlapra látogatótól az üzemeltető személyes adatot nem kér, nem gyűjt, és nem kezel.
      </p>

      <p>
        A Vállalkozás honlapjára látogatók adataival kapcsolatos tájékoztatás<br>
        A Vállalkozás honlapján tett látogatások során nem alkalmaz cookie – t
      </p>

      <p>
        Regisztráció, hírlevél feliratkozás<br>
        A Vállalkozás honlapján tett látogatáskor regisztrálni nem kell, hírlevelet nem küld.<br>
        Direkt marketing tevékenységgel kapcsolatos adatkezelés<br>
        Ilyen adatkezelést a Vállalkozás nem végez.<br>
        Webáruházzal összefüggő adatkezelés<br>
        A Vállalkozás Web áruházat nem üzemeltet.
      </p>

      <p>
        V. AZ ADATKEZELÉS CÉLJA<br>
        Kapcsolatfelvétel<br>
        A weboldalon lehetőség van anyagleadásra, ez esetben az
        adatkezelés célja szerződés teljesítése<br>
        VI. AZ ADATKEZELÉS JOGALAPJA<br>
        Az érintett hozzájárulása<br>
        A személyes adatok kezelése az Érintett hozzájárulásán alapul.<br>
        Az Érintett önkéntes hozzájárulása alapján történő adatkezelés esetén az
        Érintett a személyes adatainak kezeléséhez való hozzájárulását
        a következő formában adhatja meg:<br>
        amennyiben e-mailt küld elektronikus úton, adja meg hozzájárulását.
      </p>

      <p>
        Az érintett jogosult arra, hogy hozzájárulását bármikor visszavonja.
        A hozzájárulás visszavonása nem érinti a hozzájáruláson alapuló, a
        visszavonás előtti adatkezelés jogszerűségét.
      </p>

      <p>
        VII. ADATKEZELÉS IDŐTARTAMA<br>
        Amennyiben a kapcsolatfelvételt nem követi megrendelés, szerződéskötés,
        a személyes adatok azonnal törlésre kerülnek
      </p>

      <p>
        Az Érintett hozzájárulása visszavonásakor a személyes adatok törlésre kerülnek
      </p>

      <p>
        VIII. AZ ÉRINTETT SZEMÉLY ADATAINAK KEZELÉSÉVEL KAPCSOLATOS JOGAI<br>
        1. Rövid tájékoztatás az Érintett személy jogairól<br>
        Az Érintettnek joga van:<br>
        a tájékoztatáshoz az adatkezelés megkezdése előtt,<br>
        arra, hogy az adatkezelőtől visszajelzést kapjon arra vonatkozóan,
        hogy személyes adatainak kezelése folyamatban van-e, és ha ilyen
        adatkezelés folyamatban van, jogosult arra, hogy a személyes
        adatokhoz és a következő információkhoz,<br>
        adatainak helyesbítését, törlését kérni, értesítést kapni az
        adatkezelőtől ennek megtörténtéről,<br>
        az adatkezelés korlátozását kérni, értesítést kapni az
        adatkezelőtől ennek megtörténtéről,<br>
        az adathordozhatósághoz,<br>
        tiltakozáshoz, ha személyes adatait közérdekű célból, vagy az
        adatkezelő jogos érdekére hivatkozással kezelik.<br>
        mentesüljön az automatikus döntéshozatal alól, beleértve a profilalkotást<br>
        a felügyeleti hatóságnál való panasztételhez. Panasztételhez való jogát az érintett az
        alábbi elérhetőségeken gyakorolhatja: Nemzeti Adatvédelmi és Információszabadság Hatóság,
        cím: 1125 Budapest, Szilágyi Erzsébet fasor 22/c.,
        Telefon: +36 (1) 391-1400;Fax:+36(1)391-1410.,www:http://www.naih.hu
        e-mail: ugyfelszolgalat@naih.hu<br>
        felügyeleti hatósággal szembeni hatékony bírósági jogorvoslathoz,<br>
        az adatkezelővel szembeni hatékony bírósági jogorvoslathoz<br>
        az adatvédelmi incidensről való tájékoztatáshoz.
      </p>

      <p>
        <b>Adatkezelési tájékoztató a pályázati anyagok kezeléséről</b>
      </p>

      <p>
        Tisztelt Pályázó! Tisztelt Leendő Munkatársunk!<br>
        Pályázati anyagában, így az önéletrajzában, motivációs levelében
        megadott személyes adatai kezelésnek megkezdése előtt, továbbá
        azzal kapcsolatosan az alábbiakról tájékoztatjuk.<br>
        Adatkezelés célja:<br>
        A Körös Print-Pack Kft. betöltendő állásra történő jelentkezés,
        és a kiválasztási eljárásban való részvétel.
      </p>

      <p>
        Adatkezelés jogalapja:<br>
        Az érintett önkéntes hozzájárulása.
      </p>

      <p>
        A kezelt adatok köre:<br>
        Név, születéskori név; állandó lakcím, tartózkodási hely, telefonszám,
        e-mail cím, születési hely, idő, önéletrajz, motivációs levél,
        pályázat, valamint egyéb személyes adatok.
      </p>

      <p>
        Személyes adatok tárolásának ideje:<br>
        Amennyiben nem a pályázó került kiválasztásra az adott munkakörre,
        úgy az önéletrajz és további anyagokban szereplő személyes adatait
        haladéktalanul töröljük.<br>
        Amennyiben a pályázó az adatkezelő külön kérésére hozzájárul a
        pályázattal kapcsolatos személyes adatainak további, a pályázat
        benyújtásától számított egy (1) évig történő kezeléséhez, akkor
        a Körös Print-Pack Kft. azokat tovább kezeli.<br>
        Az egy (1) év lejártakor az adatkezelő személyes adatait törli nyilvántartásából.<br>
        A hozzájárulást követő további adatkezelés célja: betöltendő
        állásra történő jelentkezés, a kiválasztási eljárásban való részvétel.<br>
        Az adatkezelő személyes adatait papíralapon és elektronikus formában egyaránt kezeli.<br>
        Tájékoztatjuk továbbá, hogy a pályázati anyagok kezeléséhez
        az adatkezelő további adatkezelőt, adatfeldolgozót nem vesz
        igénybe, adatait sem Magyarországon, sem az Európai Unióba,
        sem azon kívülre más adatkezelőnek nem továbbítja, és nem
        adja át. Az adatkezelő nem alkalmaz automatizált adatkezelést
        és automatizált előszűrést.<br>
        Az adatkezelő az interneten található (Facebook, Linkedln, stb.)
        nyilvános és nem nyilvános adatokat nem keres, nem használ fel és nem is kezel.<br>
        A pályázati anyagban megadott személyes adatait kizárólag az
        adatkezelő vezetői és az erre a feladatra megbízott munkatársai kezelik.<br>
        Az adatkezelőhöz megküldött álláspályázatokban, önéletrajzok,
        motivációs levelekben, ajánlásokban, referencia levelekben,
        korábbi munkáltatótól kapott írásos értékelésben
        (Mt. 81. § (1) szereplő személyes adatok biztonságos
        tárolásáról és őrzéséről a Körös Print-Pack Kft. kiemelt figyelemmel gondoskodik.<br>
        Elektronikus adatbázisra vonatkozó védelmi intézkedések: Pl.:
        felhasználónév, jelszó, adatkezelő munkatársak hozzáférési
        szintjei, képernyő lezárás, stb.<br>
        Mi ellen véd? Adatok megváltoztatása, nyilvánosságra hozatala,
        illetéktelen hozzáférés, adatvesztés (törlés, megsemmisülés).<br>
        Papíralapú adatbázis védelmére vonatkozó védelmi intézkedések leírása:<br>
        A Pályázó (Érintett) jogai:<br>
        Tájékoztatáshoz való jog: jelen tájékoztató is ezt a cél szolgálja,
        hogy a Pályázó tájékozódjon személyes adatai kezelésének körülményeiről
        és az Őt megillető jogosultságairól.<br>
        Hozzáférés joga: Az adatkezelés során és annak tartama alatt bármikor kérheti.<br>
        Kérheti az adatkezelőt, hogy személyes adataiban bekövetkező változások
        alapján azokat javítsa, helyesbítse<br>
        Adathordozhatósághoz való jog: jogosult adattovábbítást kérni<br>
        Helyesbítéshez való jog: a pontatlan személyes adatok helyesbítése,
        az adatkezelés tartama alatt bármikor<br>
        Elfeledtetéshez (Törlés) való jog: az adatkezelés során bármikor
        kérhető személyes adatainak törlését<br>
        Amennyiben az adatkezelő külön kérése alapján hozzájárul, hogy személyes
        adatait a pályázat lezártát követően is kezelje, a törléshez való joga a
        meghosszabbított időtartamban is bármikor megilleti.<br>
        Adatkezelés korlátozása: amennyiben személyes adatai kezelésének
        korlátozását kéri, akkor az adatkezelő személyes adatait kizárólag
        tárolja, egyéb adatkezelés kizárólag az Érintett írásos hozzájárulásával,
        jogi igény előterjesztése céljából, vagy közérdekből lehetséges.<br>
        Jogorvoslat<br>
        Amennyiben a Pályázó (Érintett) jogsértést tapasztal az adatkezelő
        képviselőjéhez – Tóth János ügyvezetőhöz fordulhat ügyének kivizsgálása érdekében.<br>
        Az adatkezelő képviselője a megkeresésétől számított 30 napon
        belül a kérelmet elbírálja és a döntésről írásban tájékoztatást ad.<br>
        Továbbá jogorvoslatért fordulhat:<br>
        Nemzeti Adatvédelmi és Információszabadság Hatósághoz (1125 Budapest,
        Erzsébet fasor 22/c; Levelezési cím: 1530 Budapest, Pf.: 5. Telefon:
        061/391-1400, Fax: 061/391-1410, E-mail: ugyfelszolgalat@naih.hu,
        Honlap: http://www.naih.hu )<br>
        Eljárást kezdeményezhet:<br>
        A Körös Print-Pack Kft., mint adatkezelővel szemben a Gyulai Törvényszéken
        (5700 Gyula Béke sgt. 38.), de a per megindítható az érintett
        lakó- vagy tartózkodási helye szerinti törvényszék előtt is.
      </p>
      <p>
        Adatkezelő neve és adatai:<br>
        KÖRÖS PRINT – PACK KFT.<br>
        Székhely: 5600 Békéscsaba, Orosházi u. 32.<br>
        Cégjegyzékszám: 04 09 001059<br>
        Adószám: 10264175-2-04<br>
        Adatkezelés címe: 5600 Békéscsaba, Orosházi u. 32<br>
        Telefonszám: +36-66/447-608<br>
        Fax: +36-66/328-570<br>
        E-mail: info@print-pack.hu<br>
        Web: www.print-pack.hu<br>
        Képviseli: Tóth János ügyvezető
      </p>
    </div>
  </div>
</template>

<script>
import ThePageHeader from '@/components/ThePageHeader.vue';

export default {
  name: 'LegalNotice',
  components: {
    ThePageHeader,
  },
  metaInfo: {
    title: 'Adatkezelési tájékoztató | Körös PRINT-PACK Kft.',
  },
};
</script>
